module.exports = __webpack_public_path__ + "static/media/david-sweeny.a5f0515a.md";